import { JobAreaResponse } from '@doda/api-client/aspida/@types';
import { LinkList } from '../../LinkList';
import { createLinkList, nonNullableText } from '../createLinkList';

/**
 * エリアの関連リンクPropsを生成する
 * @param jobAreaResponse
 * @returns LinkList エリアの関連リンク
 */
export const createAreaLinkList = (
  jobAreaResponse?: JobAreaResponse
): LinkList => {
  return {
    separator: '＞',
    list: [
      {
        text: jobAreaResponse?.name ?? '',
        href: jobAreaResponse?.url ?? '',
        count: jobAreaResponse?.count,
        childList: createLinkList(jobAreaResponse?.prefectures, ''),
      },
    ].filter(nonNullableText),
  };
};
